module.exports = __webpack_public_path__ + "static/media/groomingIcon.af133066.png";